var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-faq-list"},[_vm._l((_vm.faqList),function(faq,index){return _c('FAQItem',{key:faq.id,attrs:{"faq":faq}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }